import api from "../Api";

const getAuthHeaders = () => {
  const token =
    localStorage.getItem("token") ||
    sessionStorage.getItem("token") ||
    null;

  return token ? { Authorization: `Bearer ${token}` } : {};
};
// ✅ Get My Named Drink Requests (User)
export const getMyDrinkRequests = async () => {
  const headers = {
    ...getAuthHeaders(),
    Accept: "application/json",
  };

  try {
    const res = await api.get("/my/requests", {
      headers,
      params: {
        api_password: "AI_Pos_passCode2026",
      },
    });

    // 🔥 parse ingredients لو راجعة string
    const normalized = res.data?.data?.map((req) => ({
      ...req,
      drink: {
        ...req.drink,
        ingredients:
          typeof req.drink?.ingredients === "string"
            ? JSON.parse(req.drink.ingredients)
            : req.drink?.ingredients,
      },
    }));

    return {
      ...res.data,
      data: normalized,
    };
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};
// ✅ Request to Name My Drink (User)
export const requestNameMyDrink = async ({
  drink_name,
  drink_name_en,
  notes,
  drink_id,
}) => {
  const headers = {
    ...getAuthHeaders(),
    Accept: "application/json",
  };

  try {
    const formData = new FormData();
    formData.append("drink_name", drink_name);
    formData.append("drink_name_en", drink_name_en);
    formData.append("notes", notes);
    formData.append("drink_id", drink_id);

    const res = await api.post(
      "/request/name/my/drink",
      formData,
      {
        headers,
        params: {
          api_password: "AI_Pos_passCode2026",
        },
      }
    );

    return res.data;
    /*
      expected:
      {
        message: "تم إرسال طلبك بنجاح",
        data: { ...request }
      }
    */
  } catch (error) {
    const serverData = error?.response?.data;
    if (serverData?.message) throw new Error(serverData.message);
    throw error;
  }
};
